import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../lib/cn";
export function TableRoot({ className, ...props }) {
    return (_jsx("div", { "data-slot": "table-root", className: cn("lg:w-full lg:overflow-x-auto lg:rounded-lg lg:border lg:border-hairline lg:bg-card", className), ...props }));
}
export function Table({ className, ...props }) {
    return (_jsx("table", { "data-slot": "table", className: cn("lg:w-full lg:border-collapse lg:text-body-sm", className), ...props }));
}
export function TableHeader({ className, ...props }) {
    return _jsx("thead", { "data-slot": "table-header", className: cn(className), ...props });
}
export function TableBody({ className, ...props }) {
    return (_jsx("tbody", { "data-slot": "table-body", className: cn("lg:[&_tr:last-child_td]:border-b-0", className), ...props }));
}
export function TableFooter({ className, ...props }) {
    return (_jsx("tfoot", { "data-slot": "table-footer", className: cn("lg:bg-brand-bg2 lg:text-caption lg:text-subtle", className), ...props }));
}
export function TableRow({ className, highlighted, ...props }) {
    return (_jsx("tr", { "data-slot": "table-row", className: cn("lg:transition-colors", highlighted === true && "lg:bg-primary/[0.06]", className), ...props }));
}
export function TableHead({ className, scope = "col", ...props }) {
    return (_jsx("th", { "data-slot": "table-head", scope: scope, className: cn("lg:whitespace-nowrap lg:border-b lg:border-hairline-2 lg:bg-brand-bg2", "lg:px-4.5 lg:py-4 lg:text-left lg:font-label lg:text-micro lg:font-medium", "lg:uppercase lg:text-muted-foreground", className), ...props }));
}
export function TableCell({ className, numeric, ...props }) {
    return (_jsx("td", { "data-slot": "table-cell", className: cn("lg:border-b lg:border-hairline lg:px-4.5 lg:py-4 lg:align-top lg:text-muted-foreground", numeric === true && "lg:whitespace-nowrap lg:font-mono lg:tabular-nums lg:text-foreground", className), ...props }));
}
export function TableCaption({ className, ...props }) {
    return (_jsx("caption", { "data-slot": "table-caption", className: cn("lg:px-4.5 lg:py-3 lg:text-left lg:text-caption lg:text-subtle", className), ...props }));
}
//# sourceMappingURL=table.js.map